import { memo } from 'react';

import { SearchOutlined } from '@ant-design/icons';
import { Button } from 'antd';

/**
 * Aktif filtreler sonuç döndürmediğinde gösterilen boş durum bileşeni.
 * @param {{ onReset: () => void }} props
 */
const FilteredEmptyState = memo(({ onReset }) => (
  <div
    className="gx-d-flex gx-align-items-center gx-justify-content-center gx-flex-column"
    style={{ padding: '40px 0', gap: 12 }}
  >
    <SearchOutlined style={{ fontSize: 64, color: '#bfbfbf' }} />
    <p className="gx-text-black gx-fs-lg gx-mb-0">Filtrelere uygun sonuç bulunamadı.</p>
    <p className="gx-mb-0">Arama kriterlerinizi değiştirerek tekrar deneyebilirsiniz.</p>
    <Button type="primary" onClick={onReset}>
      Filtreleri Temizle
    </Button>
  </div>
));

export default FilteredEmptyState;
